import { FunctionComponent } from "react";

interface BasicCardProps {
  children?: string | JSX.Element;
  onClick?: () => any;
  className?: string;
  dataTest?: string;
  role?: string;
}

const BasicCard: FunctionComponent<BasicCardProps> = ({
  children,
  onClick,
  className = "",
  dataTest,
  role,
}) => {
  return (
    <div
      className={`app-card ${onClick ? "card-hover" : ""} ${className}`}
      role={role}
      onClick={onClick}
      data-test={dataTest}
      tabIndex={onClick ? 0 : undefined}
      onKeyPress={(e) => {
        if ((e.key === "Enter" || e.key === " ") && onClick) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {children}
    </div>
  );
};

export default BasicCard;
